import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import ReactDOM from "react-dom";
import Cookies from "js-cookie";
import logo from "./../../../assets/image/icon.png";
import Notifications from "./Notifications/Notifications";
import HeaderService from "./Header.service";
import { STATUS_UNAUTHORIZED } from "./../../../config";
import "./Header.scss";
import logoutimg from "../../../assets/image/icon/logout black.png";
import notif from "../../../assets/image/icon/notif black.png";
import userp from "../../../assets/image/icon/profile black.png";

export default class Header extends Component {
    state = {
        redirect: false,
        isLoadingNotifications: false,
        showNotifications: false
    };

    logout = () => {
        Cookies.remove("userInfo");
        this.setState({
            redirect: true
        });
    };

    toggleNotifications = () => {
        this.setState({
            showNotifications: !this.state.showNotifications
        });
    };

    closeNotifications = e => {
        if (
            this.state.showNotifications &&
            e.target !== ReactDOM.findDOMNode(this.refs.notificationContainer)
        ) {
            this.setState({
                showNotifications: false
            });
        }
    };

    removeNotification = (id, accepted) => {
        let newNotifications = this.state.notifications.filter(
            notification => notification.id !== id
        );
        this.setState({
            notifications: newNotifications
        });
        if (accepted) this.props.loadBookmarks();
    };

    componentWillUnmount() {
        // document.body.removeEventListener("click", this.closeNotifications);
    }

    componentDidMount() {
        if (!this.props.userInfo) return;

        this.setState({
            isLoadingNotifications: true
        });

        HeaderService.loadNotifications(
            this.props.userInfo.username,
            this.props.userInfo.token
        )
            .then(notifications => {
                this.setState({
                    notifications
                });
            })
            .catch(error => {
                if (error.response.status === STATUS_UNAUTHORIZED) {
                    // Token expiration is handled in bookmarks request.
                    return;
                }
                this.props.alert({
                    theme: "error",
                    message: error.message
                });
            })
            .finally(() => {
                this.setState({
                    isLoadingNotifications: false
                });
            });
    }

    render() {
        if (this.state.redirect) return <Redirect to="/login" />;
        let userPanel;
        if (this.props.userInfo)
            userPanel = (
                <div className="row mr-lg-3 mr-md-3">
                    <div className="d-flex align-items-center justify-content-center position-relative">
                        <button
                            className="btn header-notifications position-relative"
                            type="button"
                            id="dropdownNotifications"
                            aria-haspopup="true"
                            aria-expanded="false"
                            onClick={this.toggleNotifications}
                        >
                            {this.state.isLoadingNotifications ? (
                                <div className="badge badge-primary position-absolute header-notifications-number">
                                    <div
                                        className="spinner-border text-light spinner-border-xs"
                                        role="status"
                                    >
                                        <span className="sr-only">
                                            Loading...
                                        </span>
                                    </div>
                                </div>
                            ) : this.state.notifications &&
                              this.state.notifications.length > 0 ? (
                                <div className="badge badge-danger position-absolute header-notifications-number">
                                    {this.state.notifications.length}
                                </div>
                            ) : (
                                ""
                            )}
                            <img className="" src={notif} alt=""/>
                        </button>
                        <div
                            ref="notificationContainer"
                            className={
                                "notification-panel dropdown-menu dropdown-menu-right " +
                                (this.state.showNotifications ? "show" : "")
                            }
                        >
                            <Notifications
                                removeNotification={this.removeNotification}
                                notifications={this.state.notifications}
                                isLoadingNotifications={
                                    this.isLoadingNotifications
                                }
                                userInfo={this.props.userInfo}
                                alert={this.props.alert}
                            />
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center">
                        <button
                            className="btn header-logged-user"
                            type="button"
                            id="dropdownMenuButton"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            <img className="" src={userp} alt=""/>
                        </button>

                        <div className="dropdown-menu dropdown-menu-right">
                            <div className="dropdown-item small d-flex flex-column align-items-center">
                                <b className="">
                                    {this.props.userInfo.complete_name}
                                </b>
                                <i className="small">
                                    @{this.props.userInfo.username}
                                </i>
                            </div>
                            <div className="dropdown-divider"></div>
                            {this.props.userInfo.group === "administrator" ? (
                                <div>
                                    <div className="dropdown-item small">
                                        <a href="adminBoard">Administrator Board</a>
                                    </div>
                                    <div className="dropdown-divider">
                                        
                                    </div>
                                </div>
                            ) : (
                                ""
                            )}
                            <button
                                className="dropdown-item small"
                                onClick={this.logout}
                            >
                            <img src={logoutimg} alt=""/>
                                Log out
                            </button>
                        </div>
                    </div>
                </div>
            );
        return (
            <header className="pl-3 pr-3 w-100 d-flex justify-content-between align-items-center">
                <div className="d-none d-sm-block ">
                <img
                    className="header-logo"
                    src={logo}
                    alt="Huckleberry logo"
                />
                <span className="title-nav">Huckleberry Board</span>

                </div>

                <div className="d-sm-none ">
                <img
                    className="header-logo"
                    src={logo}
                    alt="Huckleberry logo"
                />
                </div>
                
                
                
                {userPanel}
            </header>
        );
    }
}
